import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, CloudOff, Loader2 } from 'lucide-react';

interface SaveNotificationProps {
  show: boolean;
  onHide: () => void;
  message?: string;
  type?: 'success' | 'warning' | 'error' | 'info';
}

export function SaveNotification({ 
  show, 
  onHide, 
  message = "Changes saved", 
  type = "success" 
}: SaveNotificationProps) {
  useEffect(() => {
    if (show && type !== 'info') {
      const timer = setTimeout(() => {
        onHide();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [show, onHide, type]);

  if (!show) return null;

  const getBackgroundColor = () => {
    switch (type) {
      case 'warning': return 'bg-gold/90';
      case 'error': return 'bg-crimson/90';
      case 'info': return 'bg-electric/90';
      default: return 'bg-emerald/90';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return <AlertCircle className="h-4 w-4" />;
      case 'error':
        return <AlertCircle className="h-4 w-4" />;
      case 'info':
        return <Loader2 className="h-4 w-4 animate-spin" />;
      default:
        return <CheckCircle className="h-4 w-4" />;
    }
  };

  return (
    <div 
      className={`fixed top-4 right-4 ${getBackgroundColor()} text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 z-[100]`}
      style={{
        animation: 'slideIn 0.3s ease-out forwards'
      }}
    >
      {getIcon()}
      <span className="text-sm font-medium whitespace-nowrap">{message}</span>
    </div>
  );
}